<div class="vdi-approval-dashboard">
  <div class="dashboard-header">
    <h2>
      <i nz-icon nzType="audit"></i>
      VDI Approval Dashboard
    </h2>
    <div class="header-actions">
      <button nz-button nzType="primary" (click)="refresh()" [nzLoading]="loading">
        <i nz-icon nzType="reload"></i>
        Refresh
      </button>
    </div>
  </div>

  <!-- Permission Check -->
  <div *ngIf="!canApprove" class="permission-warning">
    <nz-alert
      nzType="warning"
      nzMessage="Limited Access"
      nzDescription="You don't have permission to approve VDI requests. Contact your administrator for access.">
    </nz-alert>
  </div>

  <!-- Statistics Cards -->
  <div class="statistics-row">
    <nz-card class="stat-card">
      <nz-statistic
        [nzValue]="totalPending"
        [nzTitle]="'Total Pending'"
        [nzValueStyle]="{ color: '#1890ff' }"
        [nzPrefix]="totalPendingIcon">
      </nz-statistic>
    </nz-card>

    <nz-card class="stat-card">
      <nz-statistic
        [nzValue]="gpuPending"
        [nzTitle]="'GPU Requests'"
        [nzValueStyle]="{ color: '#fa8c16' }"
        [nzPrefix]="gpuIcon">
      </nz-statistic>
    </nz-card>

    <nz-card class="stat-card">
      <nz-statistic
        [nzValue]="standardPending"
        [nzTitle]="'Standard Requests'"
        [nzValueStyle]="{ color: '#52c41a' }"
        [nzPrefix]="standardIcon">
      </nz-statistic>
    </nz-card>

    <nz-card class="stat-card">
      <nz-statistic
        [nzTitle]="'Avg. Wait Time'"
        [nzValue]="averageWaitTime"
        [nzValueStyle]="{ color: '#722ed1' }"
        [nzPrefix]="timeIcon">
      </nz-statistic>
    </nz-card>
  </div>

  <!-- Pending Approvals List -->
  <nz-card nzTitle="Pending Approvals" [nzLoading]="loading" [nzExtra]="listExtraTemplate">
    <ng-template #listExtraTemplate>
      <span class="approval-count" *ngIf="pendingApprovals.length > 0">
        {{ pendingApprovals.length }} pending
      </span>
    </ng-template>

    <!-- Empty State -->
    <div *ngIf="!loading && pendingApprovals.length === 0" class="empty-state">
      <nz-result
        nzStatus="success"
        nzTitle="No Pending Approvals"
        nzSubTitle="All VDI requests have been processed.">
        <div nz-result-extra>
          <button nz-button nzType="primary" (click)="refresh()">
            <i nz-icon nzType="reload"></i>
            Check Again
          </button>
        </div>
      </nz-result>
    </div>

    <!-- Approvals List -->
    <div *ngIf="pendingApprovals.length > 0" class="approvals-list">
      <nz-list
        [nzDataSource]="pendingApprovals"
        [nzRenderItem]="approvalItem"
        [nzItemLayout]="'vertical'"
        [nzSize]="'default'">
      </nz-list>
    </div>
  </nz-card>

  <!-- List Item Template -->
  <ng-template #approvalItem let-approval>
    <nz-list-item [nzActions]="[approveAction, rejectAction]">
      <nz-list-item-meta
        [nzAvatar]="avatarTemplate"
        [nzTitle]="titleTemplate"
        [nzDescription]="descriptionTemplate">
      </nz-list-item-meta>
    </nz-list-item>

    <!-- Avatar Template -->
    <ng-template #avatarTemplate>
      <nz-avatar [nzIcon]="approval.gpuRequirement ? 'deployment-unit' : 'desktop'"
                  [style.background-color]="approval.gpuRequirement ? '#fa8c16' : '#1890ff'">
      </nz-avatar>
    </ng-template>

    <!-- Title Template -->
    <ng-template #titleTemplate>
      <div class="approval-title">
        <span class="ticket-number">{{ approval.ticketNumber }}</span>
        <nz-tag [nzColor]="getGpuColor(approval.gpuRequirement)" class="gpu-tag">
          {{ getGpuLabel(approval.gpuRequirement) }}
        </nz-tag>
        <span class="requester-email">{{ approval.requesterEmail }}</span>
      </div>
    </ng-template>

    <!-- Description Template -->
    <ng-template #descriptionTemplate>
      <div class="approval-description">
        <div class="service-description" *ngIf="approval.serviceDescription">
          <strong>Service:</strong> {{ approval.serviceDescription }}
        </div>
        <div class="software-set" *ngIf="approval.softwareSet">
          <strong>Software:</strong> {{ approval.softwareSet }}
        </div>
        <div class="justification">
          <strong>Justification:</strong> {{ approval.justification }}
        </div>
        <div class="remarks" *ngIf="approval.remarks">
          <strong>Remarks:</strong> {{ approval.remarks }}
        </div>
        <div class="time-info">
          <small>
            <i nz-icon nzType="clock-circle"></i>
            Requested {{ getRelativeTime(approval.createdDate) }}
          </small>
        </div>
      </div>
    </ng-template>

    <!-- Action Templates -->
    <ng-template #approveAction>
      <button nz-button nzType="primary" nzSize="small"
              (click)="approveTicket(approval)"
              [disabled]="!canApprove || loading"
              nz-tooltip nzTooltipTitle="Approve this VDI request">
        <i nz-icon nzType="check"></i>
        Approve
      </button>
    </ng-template>

    <ng-template #rejectAction>
      <button nz-button nzType="default" nzDanger nzSize="small"
              (click)="rejectTicket(approval)"
              [disabled]="!canApprove || loading"
              nz-tooltip nzTooltipTitle="Reject this VDI request">
        <i nz-icon nzType="close"></i>
        Reject
      </button>
    </ng-template>
  </ng-template>

  <!-- Statistics Icons -->
  <ng-template #totalPendingIcon>
    <i nz-icon nzType="clock-circle"></i>
  </ng-template>

  <ng-template #gpuIcon>
    <i nz-icon nzType="deployment-unit"></i>
  </ng-template>

  <ng-template #standardIcon>
    <i nz-icon nzType="desktop"></i>
  </ng-template>

  <ng-template #timeIcon>
    <i nz-icon nzType="hourglass"></i>
  </ng-template>
</div>